import './Header.css'


const Header=()=>{
    return(
        <div className="Header">
            <img class="header-img"src="./profile pic.png" alt="Matt"/>
            <h1>Matthew Ehrlich</h1>
        </div>
    )
}
export default Header